import Resource from './Resource'

class PatientIdentifierResource extends Resource {
    async index() {
        const response = await this.axios.get(`/patients/identifiers`)
        return response.data
    }
    async getPersonIdentifiers() {
        const response = await this.axios.get(`/patients/personIdentifiers`)
        return response.data
    }
}

export default new PatientIdentifierResource()

export const PATIENT_AUTOGENERATED_GLOBAL_ID = 'identifierType.patient.autogeneratedGlobalId'
